var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 14.4H19.2C19.54 14.4 19.8248 14.2848 20.0544 14.0544C20.2848 13.8248 20.4 13.54 20.4 13.2V6C20.4 5.66 20.2848 5.3748 20.0544 5.1444C19.8248 4.9148 19.54 4.8 19.2 4.8H15.6C15.26 4.8 14.9752 4.9148 14.7456 5.1444C14.5152 5.3748 14.4 5.66 14.4 6V13.2C14.4 13.54 14.5152 13.8248 14.7456 14.0544C14.9752 14.2848 15.26 14.4 15.6 14.4ZM16.8 12V7.2H18V12H16.8ZM8.4 14.4H12C12.34 14.4 12.6252 14.2848 12.8556 14.0544C13.0852 13.8248 13.2 13.54 13.2 13.2V6C13.2 5.66 13.0852 5.3748 12.8556 5.1444C12.6252 4.9148 12.34 4.8 12 4.8H8.4C8.06 4.8 7.7752 4.9148 7.5456 5.1444C7.3152 5.3748 7.2 5.66 7.2 6V13.2C7.2 13.54 7.3152 13.8248 7.5456 14.0544C7.7752 14.2848 8.06 14.4 8.4 14.4ZM9.6 12V7.2H10.8V12H9.6ZM3.6 14.4H6V4.8H3.6V14.4ZM0 19.2V0H24V19.2H0ZM2.4 16.8H21.6V2.4H2.4V16.8Z",
    fill: "#D7D7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/Bullet.2f861a935c92ac95405ef5d4ce6d8e1a.svg";
export { ForwardRef as ReactComponent };